import React, { useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { ProtectAPi } from '../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../tools/BackButton';

const ServicesAdd = () => {

    const { http } = ProtectAPi();
    const editor = useRef(null);
    const navigate = useNavigate();

    const [loader, setLoader] = useState('off');
    const [layoutTitle, setLayoutTitle] = useState('');
    const [layoutSlug, setLayoutSlug] = useState('');
    const [layoutAltText, setLayoutAltText] = useState('');
    const [layoutDescription, setLayoutDescription] = useState('');
    const [layoutImage, setLayoutImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');

    // UPDATED: priority state (empty by default so no default value stored)
    const [priority, setPriority] = useState('');

    // NEW: Status field (default active)
    const [status, setStatus] = useState(1);

    // Error states (updated names)
    const [layoutImageError, setLayoutImageError] = useState('');
    const [titleError, setTitleError] = useState('');
    const [slugError, setSlugError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [layoutAltTextError, setLayoutAltTextError] = useState('');
    const [priorityError, setPriorityError] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'layoutTitle') setLayoutTitle(value);
        if (name === 'layoutSlug') setLayoutSlug(value);
        if (name === 'layoutAltText') setLayoutAltText(value);
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        if (!selectedImage) return;
        setLayoutImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const handlePriorityChange = (e) => {
        // keep string so empty is allowed; backend will receive '' or number string
        setPriority(e.target.value);
    };

    const handleStatusChange = (e) => {
        const n = parseInt(e.target.value, 10);
        setStatus(Number.isNaN(n) ? 1 : n);
    };

    const submitForm = () => {
        setLoader('on');
        setLayoutImageError('');
        setTitleError('');
        setSlugError('');
        setDescriptionError('');
        setLayoutAltTextError('');
        setPriorityError('');

        const formData = new FormData();
        formData.append('title', layoutTitle);
        formData.append('slug', layoutSlug);
        formData.append('alt_text', layoutAltText);
        formData.append('description', layoutDescription);
        if (layoutImage) formData.append('image', layoutImage);

        // Hidden Input (always value = 1) — name is "type" now
        formData.append('type', 1);

        // Visible dropdown status (1 = active / 2 = inactive)
        formData.append('status', String(status));

        // append new priority field (send empty string if user left it empty)
        formData.append('priority', priority === '' ? '' : String(priority));

        http.post(`/store-services`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error || {};
                setLoader('off');
                setLayoutImageError(errors.image ? errors.image[0] : '');
                setTitleError(errors.title ? errors.title[0] : '');
                setSlugError(errors.slug ? errors.slug[0] : '');
                setDescriptionError(errors.description ? errors.description[0] : '');
                setLayoutAltTextError(errors.alt_text ? errors.alt_text[0] : '');
                setPriorityError(errors.priority ? errors.priority[0] : '');
            } else {
                setLoader('off');
                navigate('/admin/pages/home/services-list');
                swal('Success', res.data.msg, 'success');
            }
        }).catch(error => {
            console.error('Error:', error);
            setLoader('off');
        });
    };

    const editorConfig = useMemo(() => ({
        readonly: false,
        placeholder: 'Start typing...',
        uploader: {
            insertImageAsBase64URI: true
        }
    }), []);

    return (
        <div className="main-content">
            <section className="section">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h5>Add Services</h5>
                                        <BackButton />
                                    </div>

                                    <div className="row mt-3">

                                        {/* Hidden input (type) */}
                                        <input type="hidden" name="type" value="1" />

                                        {/* Image Upload */}
                                        <div className="col-md-4">
                                            <label>Services Image</label>

                                            <div className="logo-box w-100">
                                                <div className="logo w-100">
                                                    <label htmlFor="layoutImage" className="w-100">
                                                        <div
                                                            className="image-box border border-dotted p-2 rounded w-100"
                                                            style={{
                                                                width: "100%",
                                                                height: "165px",
                                                                overflow: "hidden",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            }}
                                                        >
                                                            {imagePreview ? (
                                                                <img
                                                                    src={imagePreview}
                                                                    alt="Preview"
                                                                    className='rounded'
                                                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png"
                                                                    alt="Default"
                                                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                                />
                                                            )}
                                                        </div>

                                                        <input
                                                            type="file"
                                                            id="layoutImage"
                                                            className="form-control d-none"
                                                            onChange={handleImageChange}
                                                        />

                                                        <span className="btn btn-primary mt-3 w-100">Upload Services Image</span>
                                                        <span className="text-danger">{layoutImageError}</span>

                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Alt Text */}
                                        <div className="col-md-8">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label>Alt Text for Image</label>
                                                    <input type="text" name="layoutAltText" value={layoutAltText} className="form-control" placeholder="Enter alt text" onChange={handleInputChange} />
                                                    <span className="text-danger">{layoutAltTextError}</span>
                                                </div>

                                                {/* Title */}
                                                <div className="col-md-12 mt-3">
                                                    <label>Title</label>
                                                    <input type="text" name="layoutTitle" value={layoutTitle} className="form-control" placeholder="Enter title" onChange={handleInputChange} />
                                                    <span className="text-danger">{titleError}</span>
                                                </div>

                                                {/* Slug */}
                                                <div className="col-md-12 mt-3">
                                                    <label>Slug (optional)</label>
                                                    <input type="text" name="layoutSlug" value={layoutSlug} className="form-control" placeholder="Enter slug" onChange={handleInputChange} />
                                                    <span className="text-danger">{slugError}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Status Dropdown */}
                                        <div className="col-md-6 mt-3">
                                            <label>Status</label>
                                            <select
                                                className="form-control"
                                                value={status}
                                                onChange={handleStatusChange}
                                            >
                                                <option value={1}>Active</option>
                                                <option value={2}>Inactive</option>
                                            </select>
                                        </div>

                                        {/* PRIORITY (new) */}
                                        <div className="col-md-6 mt-3">
                                            <label>Priority (numeric)</label>
                                            <input
                                                type="number"
                                                name="priority"
                                                className="form-control"
                                                value={priority}
                                                onChange={handlePriorityChange}
                                                min={0}
                                                placeholder="Enter Priority"
                                            />
                                            <span className="text-danger">{priorityError}</span>
                                        </div>

                                        {/* Description */}
                                        <div className="col-md-12 mt-5">
                                            <label>Description</label>
                                            <JoditEditor
                                                ref={editor}
                                                value={layoutDescription}
                                                config={{ ...editorConfig, height: 300 }}
                                                tabIndex={1}
                                                onBlur={newContent => setLayoutDescription(newContent)}
                                                onChange={() => { }}
                                            />
                                            <span className="text-danger">{descriptionError}</span>
                                        </div>

                                        <div className="col-md-12 text-center mt-5 mb-4">
                                            {loader === 'off' ? (
                                                <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Create</button>
                                            ) : (
                                                <div className="spinner-border text-dark" role="status"></div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ServicesAdd;
